import "./ProvisionDashboard.css";

import DashboardHeader from "../../dashboard/DashboardHeader/DashboardHeader";
import DashboardStats from "../../dashboard/DashboardStats/DashboardStats";
import BusinessProgress from "../../dashboard/BusinessProgress/BusinessProgress";
import QuickActions from "../../dashboard/QuickActions/QuickActions";
import RecentOrders from "../../dashboard/RecentOrders/RecentOrders";
import RecentReviews from "../../dashboard/RecentReviews/RecentReviews";
import Notifications from "../../dashboard/Notifications/Notifications";
import RevenueChart from "../../dashboard/RevenueChart/RevenueChart";
function ProvisionDashboard({
  provider,
  stats,
  refreshDashboard,
  setDrawerOpen,
}) {
  return (
    <div className="provision-dashboard">

      <DashboardHeader
    provider={provider}
    setDrawerOpen={setDrawerOpen}
/>

      <DashboardStats
        stats={stats}
        provider={provider}
      />

      <div className="dashboard-row">

        <BusinessProgress
          stats={stats}
          provider={provider}
        />

        <QuickActions
          provider={provider}
        />

      </div>

      <RecentOrders />
      <RecentReviews />
      <Notifications />
      <RevenueChart />

    </div>
  );
}

export default ProvisionDashboard;